import { toast } from "react-toastify";
import { MASTER_PERMISSION } from "../config/apiEndPoint";
import { GET } from "config/api.config";

/** GET `master/Permission` — returns `{ data: [ { id, code, module, description } ] }`. */
export const fetchMasterPermissionsList = async () => {
  try {
    const response = await GET(MASTER_PERMISSION.LIST);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
